import { Roles } from '@/entities/roles'
import {
  MerchantExportCryptowithdrawalsCsvListParamsStatusesEnum as MerchantCryptoStatuses,
  MerchantExportTopupsCsvListParamsStatusesEnum as MerchantTopupStatuses,
  MerchantExportWithdrawalsCsvListParamsStatusesEnum as MerchantWithdrawalStatuses,
} from 'syncra-api-client'

// Типы экспорта для мерчантов и трейдеров
export const EXPORT_TYPES: Record<Roles, readonly ExportTypeConfig[]> = {
  [Roles.Merchant]: [
    { id: 'balances', label: 'Баланс', hasFilters: false },
    { id: 'withdrawals', label: 'Исходящие сделки', hasFilters: true },
    { id: 'topups', label: 'Входящие сделки', hasFilters: true },
    { id: 'cryptowithdrawals', label: 'Криптовывод', hasFilters: true },
  ],
  [Roles.Trader]: [
    { id: 'balances', label: 'Баланс', hasFilters: false },
    { id: 'withdrawals', label: 'Исходящие сделки', hasFilters: true },
    { id: 'topups', label: 'Входящие сделки', hasFilters: true },
    { id: 'cryptowithdrawals', label: 'Криптовывод', hasFilters: true },
  ],
  [Roles.Admin]: [],
  [Roles.Client]: [],
} as const

type ExportTypeConfig = {
  id: ExportType
  label: string
  hasFilters: boolean
}

export type StatusOption = {
  value: number
  label: string
}

// Статусы для фильтрации выводов (withdrawals) — соответствуют методам
// `syncraApi.v1.merchantExportWithdrawalsCsvList` / `syncraApi.v1.traderExportWithdrawalsCsvList`
export const WITHDRAWAL_STATUSES: readonly StatusOption[] = [
  { value: MerchantWithdrawalStatuses.Value1, label: 'Ожидает обработки' },
  { value: MerchantWithdrawalStatuses.Value10, label: 'Оплачен' },
  { value: MerchantWithdrawalStatuses.Value20, label: 'Оплачен частично' },
  { value: MerchantWithdrawalStatuses.Value30, label: 'Ошибка' },
  { value: MerchantWithdrawalStatuses.Value40, label: 'В обработке' },
  { value: MerchantWithdrawalStatuses.Value50, label: 'Осуществляется платеж' },
] as const

// Статусы для фильтрации пополнений (topups) — соответствуют методам
// `syncraApi.v1.merchantExportTopupsCsvList` / `syncraApi.v1.traderExportTopupsCsvList`
export const TOPUP_STATUSES: readonly StatusOption[] = [
  { value: MerchantTopupStatuses.Value1, label: 'Ожидает оплаты' },
  { value: MerchantTopupStatuses.Value2, label: 'Подтверждено плательщиком' },
  { value: MerchantTopupStatuses.Value11, label: 'Оплачено' },
  { value: MerchantTopupStatuses.Value12, label: 'Отменено' },
  { value: MerchantTopupStatuses.Value13, label: 'Просрочено' },
  { value: MerchantTopupStatuses.Value14, label: 'Переплата' },
  { value: MerchantTopupStatuses.Value15, label: 'Частичная оплата' },
  { value: MerchantTopupStatuses.Value16, label: 'Возвращено' },
  { value: MerchantTopupStatuses.Value21, label: 'Спор' },
  { value: MerchantTopupStatuses.Value31, label: 'Ожидает платежного канала' },
  { value: MerchantTopupStatuses.Value32, label: 'В откате' },
  { value: MerchantTopupStatuses.Value1000, label: 'Неизвестный' },
] as const

// Статусы для фильтрации крипто-выводов — соответствуют методам
// `syncraApi.v1.merchantExportCryptowithdrawalsCsvList` / `syncraApi.v1.traderExportCryptowithdrawalsCsvList`
export const CRYPTO_WITHDRAWAL_STATUSES: readonly StatusOption[] = [
  { value: MerchantCryptoStatuses.Value1, label: 'Создан' },
  { value: MerchantCryptoStatuses.Value2, label: 'В обработке' },
  { value: MerchantCryptoStatuses.Value3, label: 'Завершен' },
  { value: MerchantCryptoStatuses.Value4, label: 'Ошибка' },
] as const

// Маппинг статусов по типам экспорта
export const STATUS_OPTIONS_BY_TYPE: Record<ExportType, readonly StatusOption[]> = {
  balances: [],
  withdrawals: WITHDRAWAL_STATUSES,
  topups: TOPUP_STATUSES,
  cryptowithdrawals: CRYPTO_WITHDRAWAL_STATUSES,
}

// Форматы экспорта
export const EXPORT_FORMATS = [
  { value: 'csv', label: 'CSV' },
]

// Типы экспорта
export type ExportType = 'balances' | 'withdrawals' | 'topups' | 'cryptowithdrawals'
export type ExportFormat = 'csv'
